import React from 'react';
import { PhoneIcon } from 'lucide-react';
import { SITE } from '../../data/site';
export function TopBar() {
  return <div className="gutter relative z-50 flex h-9 items-center justify-between gap-4 bg-ink text-xs text-chrome-300 sm:text-[13px]" data-id="element-437" data-mp="3c0lylp11x7b6">
      <p className="hidden truncate md:block" data-id="element-438" data-mp="2y24h491qor1p">Sheriff-approved Nevada CCW instructors since {SITE.since}</p>
      <a href={SITE.phoneHref} className="flex items-center gap-1.5 font-semibold text-white hover:text-chrome-100" data-id="element-439" data-mp="323g56a4yt47s">
        <PhoneIcon className="h-3.5 w-3.5 text-accent-bright" aria-hidden="true" data-id="element-440" data-mp="3uq0wxbpcribv" />
        {SITE.phoneDisplay}
      </a>
      <p className="truncate" data-id="element-441" data-mp="3gzp3n9h17dj5">We train 7 days a week</p>
    </div>;
}